import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ComparisonCard from "../components/ComparisonCard";
import { COMPARISONS } from "../data/comparisons";
import NewsletterCTA from "../components/NewsletterCTA";

export default function WhyMillets() {
  return (
    <main data-testid="page-why-millets">
      {/* Hero — Cobalt solid */}
      <section className="relative overflow-hidden border-b-2 border-jet bg-cobalt pt-[104px] text-cream md:pt-[128px]">
        <div className="relative grid lg:grid-cols-2">
          <div className="border-b-2 border-cream/30 p-8 md:p-14 lg:border-b-0 lg:border-r-2 lg:p-20">
            <p className="font-sans text-xs font-extrabold uppercase tracking-[0.22em] text-butter">
              § Showdown
            </p>
            <h1 className="mt-4 font-sans text-6xl font-extrabold leading-[1] tracking-tight md:text-8xl lg:text-[7rem]">
              Why <span className="text-butter">millets</span>?
            </h1>
            <p className="mt-8 max-w-xl font-sans text-lg font-semibold leading-snug md:text-xl">
              Six head-to-heads with the grains &amp; proteins in your pantry. We're
              not pretending to be neutral — but every stat below is checkable.
            </p>
          </div>
          <div className="flex flex-col justify-between p-8 md:p-14 lg:p-20">
            <p
              className="font-sans text-[22vw] font-black leading-[0.82] tracking-tight md:text-[16vw] lg:text-[11rem]"
              style={{
                color: "#F2CD1A",
                WebkitTextStroke: "4px #0B0B0F",
                textShadow: "8px 8px 0 #E7100E",
              }}
            >
              VS.
            </p>
            <ul className="mt-8 grid grid-cols-2 gap-3 font-sans text-sm font-bold">
              {COMPARISONS.map((c) => (
                <li key={c.slug}>
                  <a
                    href={`#${c.slug}`}
                    data-testid={`anchor-${c.slug}`}
                    className="inline-block border-b-2 border-cream hover:text-butter"
                  >
                    Millet vs {c.competitor} →
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Grid of comparison cards */}
      <section
        data-testid="section-comparisons"
        className="border-b-2 border-ink bg-cream p-6 md:p-14 lg:p-20"
      >
        <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-2">
          {COMPARISONS.map((c, i) => (
            <div key={c.slug} id={c.slug} className="scroll-mt-24">
              <ComparisonCard comparison={c} index={i} />
            </div>
          ))}
        </div>
      </section>

      {/* Newsletter — shared orange section (replaces the green CTA) */}
      <NewsletterCTA source="why-millets" id="newsletter" />
    </main>
  );
}
